import React from 'react';
import './PDFViewer.css';

const PDFViewer = ({ pdfPath }) => {
    return (
        <iframe
            src={pdfPath}
            width='100%'
            height='100%'
            title='PDF Viewer'
        />
    );
};

export default PDFViewer;
